module.exports = __webpack_public_path__ + "img/hr-sand-decal-03.9e044996.png";